import styled from 'styled-components'

export default styled('div')`
  color: ${props => props.theme.cube.textColor};
  font-size: 22px;
  font-weight: 500;
  margin: 0 0 16px;
`
